import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';

const VOC_TAG = 'Voc';

dcpcApi.enhanceEndpoints({ addTagTypes: [VOC_TAG] });

const vocApi = dcpcApi.injectEndpoints({
    endpoints: (builder) => ({
        getVoc: builder.query({
            query: () => 'voc',
            providesTags: [VOC_TAG],
        }),
    }),
});

export const {
    useGetVocQuery,
} = vocApi;

export const vocSelect = (state) => vocApi.endpoints.getVoc.select()(state);

//
export const descriptorsSelector = (state) => vocSelect(state)?.data?.descriptors || [];
export const codesSelector = (state) => vocSelect(state)?.data?.codes || [];
export const filterDescriptorsBySearchTextSelector = createSelector(
  descriptorsSelector,
  (_, searchText) => searchText,
  (descriptors, searchText) => ({
    columns: [
      {
        label: 'Параметр',
      },
      {
        label: 'Описание',
      },
    ],
    rows: descriptors.reduce((acc, cur) => {
      const { id, name, description } = cur;
      const row = [id, name, description].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [{
      label: 'Редактировать',
      to: (id) => `${id}`,
      icon: EditIcon,
    }],
    createLink: {
      label: 'Создать параметр',
    },
  }),
);

export const descriptorsBySearchTextSelector = (searchText) => (state) => filterDescriptorsBySearchTextSelector(state, searchText);

//
export const descriptorTypesSelector = (state) => vocSelect(state)?.data?.descriptor_types;
export const filterDescriptorTypesBySearchTextSelector = createSelector(
  descriptorTypesSelector,
  (_, searchText) => searchText,
  (descriptorTypes, searchText) => {
      const rows = descriptorTypes.reduce((acc, cur) => {
          const { id, type } = cur;
          const row = [id, type].map((v) => v || '');
          if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
              acc.push(row);
          }
          return acc;
      }, []);
      return {
          columns: [
              {
                  label: 'Тип параметров',
              },
          ],
          rows,
      };
  },
);

export const descriptorTypesBySearchTextSelector = (searchText) => (state) => filterDescriptorTypesBySearchTextSelector(state, searchText);
